import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'

export const RecaptchaScoreError = () => {
  const { t } = useTranslation()

  return (
    <Box flexCol align="center" gapY={16} aria-label="low recaptcha score error">
      <p className="text-body-regular text-foreground-prominent">
        {t('recaptcha.verificationFailed')}
      </p>
      <p className="text-body-regular text-foreground-prominent">
        {t('recaptcha.scoreError.description')}
      </p>

      <ul className="list-disc pl-6">
        <li>{t('recaptcha.scoreError.multipleAttempts')}</li>
        <li>{t('recaptcha.scoreError.vpn')}</li>
        <li>{t('recaptcha.scoreError.browser')}</li>
      </ul>
    </Box>
  )
}
